"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PingbackContext = void 0;
var js_analytics_1 = require("@giphy/js-analytics");
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
exports.PingbackContext = (0, preact_1.createContext)({});
var PingbackContextManager = function (_a) {
    var attributes = _a.attributes, children = _a.children;
    var _b = (0, hooks_1.useContext)(exports.PingbackContext).attributes, parentAttributes = _b === void 0 ? {} : _b;
    return ((0, preact_1.h)(exports.PingbackContext.Provider, { value: { attributes: (0, js_analytics_1.mergeAttributes)(parentAttributes, attributes, 'layout_type') } }, children));
};
exports.default = PingbackContextManager;
//# sourceMappingURL=pingback-context-manager.js.map